// src/config/mqtt.js
export const MQTT_CONFIG = {
  brokerUrl:
    "wss://6225f5860bef41b88da4d2b83687e9b9.s1.eu.hivemq.cloud:8884/mqtt",
  username: "datkiosk-client",
  password: "QZ7P7KPCZ4Q@je4",
  topics: ["refresh_page"],
  clientId: `app-${Math.random().toString(36).substr(2, 9)}`,
};